/* Голос варианта «Вы» в форме «Свой аватар». Сервер публикует его одним из двух полей:
   - `voice_id` — число голоса (прежняя форма);
   - `voice` — объект `{mode: "clone" | "catalog" | "later", voice_id?}` (docs/03-api.md «Свой аватар», контракт экрана avatar
     в steos-backend: Obj("voice", En("mode"…).Req(), Int("voice_id"))), значение поля — JSON-текст (value_encoding: json).
   Голая цифра в объектном поле уходит на сервер числом и получает 422 — поэтому значение строится по виду поля. */

interface VoiceField {
  key: string;
  type?: string;
}

const objectField = (field: VoiceField) => field.type === 'object' || field.key === 'voice';

/** Значение поля для выбранного своего готового клона */
export function avatarVoiceValue(field: VoiceField, voiceId: number): string {
  return objectField(field) ? JSON.stringify({ mode: 'clone', voice_id: voiceId }) : String(voiceId);
}

/** Выбранный голос (id строкой) или '' — «Позже» и пустое поле */
export function avatarVoicePicked(field: VoiceField, raw: string | undefined): string {
  if (!raw) return '';
  if (!objectField(field)) return raw;
  try {
    const value = JSON.parse(raw) as { mode?: unknown; voice_id?: unknown };
    return value && value.mode !== 'later' && typeof value.voice_id === 'number' ? String(value.voice_id) : '';
  } catch {
    return '';
  }
}
